<template>
  <div class="w-full h-auto py-[3.75vw] bg-[#F5F5F7]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          新闻资讯
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          蓝悦动态，见证成长
        </div>
      </div>
    </div>

    <!-- 内容框区域 -->
    <div class="relative w-[61.46vw] h-[15.10vw] mx-auto flex justify-between">
      <!-- 左侧内容框 -->
      <div class="w-[28.96vw] h-full flex flex-col"   >
        <div
                v-show="leftContent.base64Value.length>0"
          class="w-full h-full flex flex-col justify-between rounded hover:shadow-lg transition-all duration-300 cursor-pointer"
          @click="navigateToDetail(leftContent.documentId)"
        >
          <!-- 图片容器 -->
          <div
            class="w-full h-[12.76vw] my-auto flex items-center flex-shrink-0"
          >
            <img
              class="w-full h-full object-center object-cover rounded-t"
              :src="leftContent.base64Value"
            />
          </div>
          <!-- 文本部分 -->
          <div class="w-full flex justify-between items-center pb-[0.10vw]">
            <div class="flex justify-start items-center gap-[0.26vw]">
              <div
                class="w-[0.26vw] h-[0.26vw] bg-[#003ca8] rounded-full"
              ></div>
              <div
                class="justify-start w-[21vw] text-[#676b73] text-[0.94vw] font-normal font-harmony"
              >
                {{ truncateTitle(leftContent.title) }}
              </div>
            </div>
            <div
              class="text-right justify-start text-[#9ca2af] text-[0.83vw] font-normal font-harmony uppercase"
            >
              {{ leftContent.publicData | formatZhDate }}
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧内容框 -->
      <div class="w-[28.96vw] h-full bg-transparent rounded-xl flex flex-col">
        <!-- 按钮组合 -->
        <div class="w-full h-[2.76vw] flex justify-between">
          <button
            v-for="(button, index) in buttons"
            :key="index"
            :class="[
              'w-[9.69vw] h-[2.76vw] px-[1.56vw] py-[0.57vw] rounded-tl rounded-bl inline-flex justify-center items-center gap-[0.26vw] ',
              activeButton === index ? 'bg-[#05358c]' : 'bg-white',
            ]"
            @click="titleClick(index)"
          >
            <span
              :class="[
                'justify-start text-[0.83vw] font-medium font-harmony ',
                activeButton === index ? 'text-white' : 'text-[#333]',
              ]"
            >
              {{ button }}
            </span>
          </button>
        </div>

        <!-- 新闻内容框 -->
        <div class="w-full h-[11.3vw] mt-[1.04vw] overflow-hidden">
          <div
            v-for="(item, index) in visibleNewsItems"
            :key="item.id"
            @click="navigateToDetail(item.id)"
            class="h-[calc(11.3vw/6)] flex justify-between items-center hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
          >
            <!-- 内容保持不变 -->
            <div class="flex justify-start items-center gap-[0.26vw]">
              <div
                class="w-[0.26vw] h-[0.26vw] bg-[#003ca8] rounded-full"
              ></div>
              <div
                class="justify-start text-[#676b73] text-[0.83vw] font-normal font-harmony"
              >
                {{ truncateTitle(item.newsTitle) }}
              </div>
            </div>
            <div
              class="text-right justify-start text-[#9ca2af] text-[0.73vw] font-normal font-harmony uppercase"
            >
              {{ item.publishedAt | formatZhDate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 按钮容器 -->
    <el-button
      plain
      class="custom-el-button font-harmony relative mx-auto mt-[2.2vw] flex justify-between"
      @mouseenter="hoverButton = true"
      @mouseleave="hoverButton = false"
      @click="$router.push({ name: 'News' })"
    >
      <div class="w-full h-full flex items-center justify-center gap-[0.52vw]">
        <span>查看更多</span>
        <i class="el-icon-plus"></i>
      </div>
    </el-button>
  </div>
</template>

<script>
import axios from "axios";
import {quickGetNews} from "@/api/newsInfo";
// 分类标识映射关系（保持与项目其他部分一致）
const categoryMap = {
  公司新闻: "company_公司新闻",
  加盟动态: "join_加盟动态",
  行业资讯: "industry_行业资讯",
};

export default {
  name: "home-module7",
  data() {
    return {
        totalContent:[],
        leftContent: {
          documentId:"",
          base64Value: "",
          title: "",
          publicData:""
      },
      buttons: ["公司新闻", "加盟动态", "行业资讯"],
      activeButton: 0,
      newsData: {
        公司新闻: [],
        加盟动态: [],
        行业资讯: [],
      },
    };
  },
  created() {
    this.fetchHomeNews("company_公司新闻");
  },
  computed: {
    visibleNewsItems() {
      // const currentCategory = this.buttons[this.activeButton];
      // 限制最多6条数据
      return this.totalContent.splice(1,7)|| [];
    },
  },
  methods: {
    // 统一参数构建方法
    // buildQueryParams(category) {
    //   const params = {
    //     populate: "*",
    //     sort: "publishedAt:desc",
    //     "pagination[limit]": 6,
    //     "filters[news_status][$eq]": "publish_发布",
    //   };
    //
    //   if (category) {
    //     params["filters[news_category][$eq]"] = categoryMap[category];
    //   }
    //
    //   return new URLSearchParams(params).toString();
    // },

    async fetchHomeNews(category) {
      try {
        // const baseUrl = "/api";

        // 创建并行请求
        // const requests = this.buttons.map((button) => {
        //   const query = this.buildQueryParams(button);
        //   return axios.get(`${baseUrl}/newsinfos?${query}`);
        // });
        const responses =await quickGetNews(category);
        // const responses = await Promise.all(requests);
        //   console.log(11111,responses)
          if(responses.data.length === 0){
              this.leftContent = {
                  documentId:"",
                  base64Value: "",
                  title: "",
                  publicData:""
              };
              this.totalContent = [];
              return;
          }
        this.leftContent.documentId = responses.data[0].id;
        this.leftContent.base64Value = responses.data[0].photoContent;
        this.leftContent.title = responses.data[0].newsTitle;
        this.leftContent.publicData = responses.data[0].publishedAt;
          // console.log(responses)
          this.totalContent = responses.data;

      } catch (error) {
        // console.error("首页新闻数据获取失败：", error);
        // 可在此处添加错误处理逻辑
        //   ElementUI.Message.error(error)
      }
    },titleClick(index){
        this.activeButton = index;
        if(index === 0){
            this.fetchHomeNews("company_公司新闻")
        }else if(index === 1){
            this.fetchHomeNews("join_加盟动态")
        }else {
            this.fetchHomeNews("industry_行业资讯")
        }
      },
    // 以下方法保持不变
    goToPage() {
      this.$router.push({ name: "News" });
      window.scrollTo({ top: 0 });
    },
    navigateToDetail(documentId) {
      this.$router.push({
        path: `/News/info/${documentId}`,
      });
    },
    truncateTitle(title) {
      //   如果标题超过20个字，进行截取
      const maxLength = 20;
      return title.length > maxLength
        ? title.slice(0, maxLength) + "..."
        : title;
    },
  },
};
</script>

<style scoped>
/* 自定义按钮样式 */
.custom-el-button {
  width: 6.25vw !important;
  height: 1.82vw !important;
  border-color: #e4e7ed !important;
  color: #676b73 !important;
  transition: all 0.3s ease !important;
}

/* 文字图标样式 */
.custom-el-button :deep(span),
.custom-el-button :deep(.el-icon-plus) {
  color: #676b73 !important;
  font-size: 0.73vw !important;
}

/* 悬停状态 */
.custom-el-button:hover {
  border-color: #05358c !important;
  color: #05358c !important;
  background-color: rgba(5, 53, 140, 0.1) !important;
}
.custom-el-button:hover :deep(span),
.custom-el-button:hover :deep(.el-icon-plus) {
  color: #05358c !important;
}
</style>
